import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxMsgComponent } from "./ngx-msg.component";
import { NgxMsgService } from "./services/ngx-msg.service";
import { NgxMsgConfigService } from "./services/ngx-msg-config.service";
export var NgxMsgModule = (function () {
    function NgxMsgModule() {
    }
    NgxMsgModule.forRoot = function () {
        return {
            ngModule: NgxMsgModule,
            providers: [NgxMsgConfigService, NgxMsgService]
        };
    };
    NgxMsgModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [NgxMsgComponent],
                    exports: [NgxMsgComponent]
                },] },
    ];
    NgxMsgModule.ctorParameters = [];
    return NgxMsgModule;
}());
//# sourceMappingURL=ngx-msg.module.js.map